import './Error.scss'
import { Col, Row } from 'react-bootstrap'

export default function Error({ error, className = 'my-5' }) {
  // Return early if we don't have an error
  if (!error) return null

  return (
    <Row className={`error ${className}`}>
      <Col>
        <strong>
          <i className='icon bi-exclamation-circle'></i> Error:{' '}
        </strong>{' '}
        {error}
      </Col>
    </Row>
  )
}
